import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule, MatChipsModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatSelectModule } from '@angular/material';
import { RouterModule } from '@angular/router';
import { NgbTabsetModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DxDataGridModule, DxLookupModule, DxScrollViewModule, DxTagBoxModule } from 'devextreme-angular';
import { CaptionPipe } from 'src/app/core/_base/layout/pipes/caption.pipe';
import { TagExistPipe } from 'src/app/core/_base/layout/pipes/tag-exist.pipe';
import { TagFilterPipe } from 'src/app/core/_base/layout/pipes/tag-filter.pipe';
import { TagNamePipe } from 'src/app/core/_base/layout/pipes/tag-name.pipe';
import { CoreModule } from '../../../core/core.module';
import { AccomodationCardPopup } from './accomodation-card/accomodation-card.popup';
import { AdditionalInfoPopup } from './additional-info/additional-info.popup';
import { ChangeHotelPopup } from './change-hotel/change-hotel.popup';
import { ChangeImagePopup } from './change-image/change-image.popup';
import { ItemCatalogPopup } from './item-catalog/item-catalog.popup';
import { ItemPopup } from './item/item.popup';
import { LanguageTranslatePopup } from './language-translate/language-translate.popup';
import { NewItemPopup } from './new-item/new-item.popup';
import { NewPromotionComponent } from './new-promotion/new-promotion.component';
import { NewRequestComponent } from './new-request/new-request.component';
import { NewReservationComponent } from './new-reservation/new-reservation.component';
import { PaymentInfoPopup } from './payment-info/payment-info.popup';
import { PoisPopup } from './pois/pois.popup';
import { PopupComponent } from './popup.component';
import { ProfileEditPopup } from './profile-edit/profile-edit.popup';
import { RequestChatComponent } from './request-chat/request-chat.component';
import { ReservationPerHourPopup } from './reservation-per-hour/reservation-per-hour.popup';
import { SelectSectionPopup } from './select-section/select-section.popup';
import { UserEditPopup } from './user-edit/user-edit.popup';

@NgModule({
  declarations: [
    PopupComponent,
    NewItemPopup,
    AdditionalInfoPopup,
    LanguageTranslatePopup,
    ItemCatalogPopup,
    ItemPopup,
    SelectSectionPopup,
    PoisPopup,
    ChangeHotelPopup,
    ChangeImagePopup,
    RequestChatComponent,
    ProfileEditPopup,
    UserEditPopup,
    AccomodationCardPopup,
    ReservationPerHourPopup,
    PaymentInfoPopup,
    NewRequestComponent,
    NewReservationComponent,
    TagFilterPipe,
    TagNamePipe,
    TagExistPipe,
    NewPromotionComponent
  ],
  entryComponents: [
    NewItemPopup,
    AdditionalInfoPopup,
    LanguageTranslatePopup,
    ItemCatalogPopup,
    ItemPopup,
    SelectSectionPopup,
    PoisPopup,
    ChangeHotelPopup,
    ChangeImagePopup,
    ProfileEditPopup,
    UserEditPopup,
    AccomodationCardPopup,
    ReservationPerHourPopup,
    PaymentInfoPopup,
    NewRequestComponent,
    NewReservationComponent,
    NewPromotionComponent
  ],
  exports: [
    SelectSectionPopup,
    RequestChatComponent,
    NewRequestComponent,
    NewReservationComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    MatChipsModule,
    MatIconModule,
    MatFormFieldModule,
    CoreModule,
    TranslateModule.forChild(),
    NgbTabsetModule,
    MatSelectModule,
    DxDataGridModule,
    DxScrollViewModule,
    DxLookupModule,
    DxTagBoxModule
  ],
  providers: [CaptionPipe]
})
export class PopupModule {
}
